<div class="rendition-form-load-draft-container">
  <p>
    La reserva <b>“{{ this.address }}”</b> ya cuenta con un borrador. ¿Qué desea hacer?
  </p>
</div>
